import FlowBase from './FlowBase';
import {flowsconfig} from '../config/flowsconfig';

export {FlowBase};


export const findWorkflow = (service:string) => {
  const flows:any = flowsconfig;
  return flows[service];
}

export const getWorkflow = (service:string) => {
  const flows:any = flowsconfig;
  return flows[service];
}
